// GENERATED by `npm run icons:sync` — do not edit by hand.
import { createLucideIcon } from 'lucide-react';

export const Users = /*#__PURE__*/ createLucideIcon('Users', [ ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }], ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }], ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }], ["path", { d: "M16 3.13a4 4 0 0 1 0 7.75", key: "1da9ce" }] ]);
